module.exports = __webpack_public_path__ + "img/coin.840f8ece.svg";